const DefinitionHandleSelectAll = (idIndex, argPayload) => {
  const {
    courseList,
    defaultSelectedIds,
    setUnselectedRows,
    setSelectedRows,
    setSelectAllItems,
    selectAllItems,
    unselectedRows,
  } = argPayload;

  const newSelectedRows = [];
  let newUnselectedRows = [];

  courseList.forEach(row => {
    row[row.length - 1] = !selectAllItems;
  });

  if (selectAllItems) {
    // selectAllItems equals true but will be false
    // that's why setSelectedRows is cleaned
    courseList.forEach(row => {
      if (defaultSelectedIds.includes(row[idIndex])) {
        // adds unselected row that was originally selected
        if (!unselectedRows.some(course => course.id === row[idIndex])) {
          newUnselectedRows.push({ id: row[idIndex], value: false });
        }
      }
    });
  } else {
    // selectAllItems equals false but will be true
    // that's why setSelectedRows is filled
    newUnselectedRows = unselectedRows;

    courseList.forEach(row => {
      if (defaultSelectedIds.includes(row[idIndex])) {
        // deletes re-checked row from unselectedRows
        newUnselectedRows = newUnselectedRows.filter(course => course.id !== row[idIndex]);
      } else {
        newSelectedRows.push({ id: row[idIndex], value: true });
      }
    });
  }

  setUnselectedRows(Array.from(newUnselectedRows));
  setSelectedRows(Array.from(newSelectedRows));

  setSelectAllItems(!selectAllItems);
};

export default DefinitionHandleSelectAll;
